"use strict";

exports.__esModule = true;
exports.ConditionTypeFilter = void 0;
var _core = require("@blueprintjs/core");
var _Selector = require("../../Core/Selector");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _CommonValidators = require("../utils/CommonValidators");
var _DataItemTypeSelect = require("../Common/DataItemTypeSelect");
var _styles = require("../styles");
var _operators = require("./operators");
var _vimanaTypes = require("@vimana/vimana-types");
var _EnrichDefinitionContext = require("../EnrichDefinitionContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ConditionTypeFilter = exports.ConditionTypeFilter = function ConditionTypeFilter(_ref) {
  var operator = _ref.operator,
    dataItems = _ref.dataItems,
    isOpen = _ref.isOpen,
    setOpen = _ref.setOpen,
    setDataItems = _ref.setDataItems,
    setOperator = _ref.setOperator;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_EnrichDefinitionContext.EnrichDefinitionContext),
    device = _useContext2.device;
  var _useState = (0, _react.useState)([]),
    dataItemNames = _useState[0],
    setDataItemNames = _useState[1];
  var setNamesForSelectedDataItem = function setNamesForSelectedDataItem(dataItem, index) {
    var _device$dataItems;
    var names = device == null || (_device$dataItems = device.dataItems) == null ? void 0 : _device$dataItems.filter(function (item) {
      return (item == null ? void 0 : item.type) === (dataItem == null ? void 0 : dataItem.type);
    }).map(function (item) {
      return item == null ? void 0 : item.name;
    });
    dataItemNames.splice(index, 1, names);
    setDataItemNames(dataItemNames);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    "data-testid": "ConditionTypeFilterCheckbox",
    checked: isOpen,
    onChange: function onChange(e) {
      return setOpen(e.currentTarget.checked);
    }
  }, translate("EnrichEditorUI.ConditionClassify.ConditionTypeFilter", "Condition type filter")), isOpen ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, null, /*#__PURE__*/_react["default"].createElement("span", null, translate("EnrichEditorUI.ConditionClassify.Operator", "Operator")), /*#__PURE__*/_react["default"].createElement(_styles.Spacer, null), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    dataTestId: "ConditionTypeFilterSelector",
    items: _operators.IN_OPERATORS,
    getKey: function getKey(operator) {
      return operator.value;
    },
    renderItemText: function renderItemText(operator) {
      return operator.displayName;
    },
    selected: operator && [operator],
    onSelect: function onSelect(_ref2) {
      var newOperator = _ref2[0];
      return setOperator(newOperator);
    }
  }, !(0, _CommonValidators.validateSelector)(operator) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  }, {
    itemPredicate: function itemPredicate(query, item) {
      return item.value.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  }))), dataItems == null ? void 0 : dataItems.map(function (item, i, a) {
    var _item$dataItem, _dataItemNames$i, _item$dataItem2;
    return /*#__PURE__*/_react["default"].createElement(_styles.Row, {
      key: item.name
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        whiteSpace: "nowrap"
      }
    }, translate("EnrichEditorUI.ConditionClassify.DataItems", "Data items")), /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement(_DataItemTypeSelect.DataItemTypeSelect, _extends({
      dataTestId: "EnrichEditorUI.ConditionClassify.DataItem.Type",
      getKey: function getKey(dataItem) {
        return dataItem.type + "." + dataItem.name;
      },
      renderItemText: function renderItemText(dataItem) {
        return dataItem.type;
      },
      placeholder: translate("EnrichEditorUI.Condition.DataItem", "Data item"),
      selected: item.dataItem && [item.dataItem],
      onSelect: function onSelect(_ref3) {
        var dataItem = _ref3[0];
        a[i] = {
          dataItem: dataItem
        };
        setDataItems(a);
        setNamesForSelectedDataItem(dataItem, i);
      }
    }, !(0, _CommonValidators.validateSelector)((_item$dataItem = item.dataItem) == null ? void 0 : _item$dataItem.type) && {
      style: Object.assign({}, true && {
        border: "solid 1px red"
      })
    })), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
      dataTestId: "EnrichEditorUI.ConditionClassify.DataItem.Name",
      items: (_dataItemNames$i = dataItemNames[i]) != null ? _dataItemNames$i : [],
      getKey: function getKey(dataItemName) {
        return "" + dataItemName;
      },
      renderItemText: function renderItemText(dataItemName) {
        return dataItemName;
      },
      selected: ((_item$dataItem2 = item.dataItem) == null ? void 0 : _item$dataItem2.name) && [item.dataItem.name],
      onSelect: function onSelect(_ref4) {
        var dataItemName = _ref4[0];
        item.dataItem.name = dataItemName;
        a[i] = Object.assign({}, item);
        setDataItems(a);
      },
      itemPredicate: function itemPredicate(query, item) {
        return item.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      }
    })), /*#__PURE__*/_react["default"].createElement(_styles.ClassifyAddButtonsContainer, null, i === 0 ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "AddCondition",
      icon: "plus",
      intent: _core.Intent.PRIMARY,
      onClick: function onClick() {
        setDataItems(dataItems.concat([{}]));
        setDataItemNames(function (prev) {
          return [].concat(prev, [{
            index: prev.length,
            names: []
          }]);
        });
      }
    }) : /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "DeleteRow",
      icon: "minus",
      onClick: function onClick() {
        a.splice(i, 1);
        setDataItems(a);
      }
    })));
  })) : null);
};